export const folderIdQueryParam = 'folderId';
